import { makeStyles } from '@material-ui/core/styles';

const useForgotPasswordInStyle = makeStyles(({ palette }) => ({
  buttonLoading: {
    color: palette.common.white
  }
}));

export default useForgotPasswordInStyle;
